import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { LightboxModule } from 'ngx-lightbox';
import { NgOptimizedImage } from '@angular/common'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home.component';
import { FeaturesComponent } from './features.component';
import { PricingComponent } from './pricing.component';
import { GuideComponent } from './guide.component';
import { FooterComponent } from './footer.component';
import {NgsRevealModule} from 'ngx-scrollreveal';
import { GalleryScrollDirective } from './gallery-scroll.directive';
import { HeroComponent } from './hero/hero.component';
import { ContactComponent } from './contact/contact.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { DashEnterpriseAuthComponent } from './dash-enterprise-auth/dash-enterprise-auth.component';
import { GuideO365PowershellComponent } from './guide-o365-powershell/guide-o365-powershell.component';
import { GuideO365ServiceAccountComponent } from './guide-o365-service-account/guide-o365-service-account.component';
import { GuideGoogleComponent } from './guide-google/guide-google.component';
import { GuideGooglePersonalAccountComponent } from './guide-google-personal-account/guide-google-personal-account.component';
import { GuideGoogleServiceAccountComponent } from './guide-google-service-account/guide-google-service-account.component';
import { GuideO365Component } from './guide-o365/guide-o365.component';
import { GuideO365EnterpriseApplicationComponent } from './guide-o365-enterprise-application/guide-o365-enterprise-application.component';
import { GuideEnterpriseComponent } from './guide-enterprise/guide-enterprise.component';
import { GuideEnterpriseDashboardComponent } from './guide-enterprise-dashboard/guide-enterprise-dashboard.component';
import { GuideEnterpriseMdmComponent } from './guide-enterprise-mdm/guide-enterprise-mdm.component';
import { GuideEnterpriseDashboardConfigurationComponent } from './guide-enterprise-dashboard-configuration/guide-enterprise-dashboard-configuration.component';
import { EnterpriseTabNavigatorComponent } from './enterprise-tab-navigator/enterprise-tab-navigator.component';
import { EnterpriseConfigurationValuesComponent } from './enterprise-configuration-values/enterprise-configuration-values.component';
import { ThumbnailComponent } from './thumbnail/thumbnail.component';
import { DataDeletionComponent } from './data-deletion/data-deletion.component';
import { GuideEnterpriseUserAdministrationComponent } from './guide-enterprise-user-administration/guide-enterprise-user-administration.component';
import { HardwareComponent } from './hardware/hardware.component';
import { GuideEnterpriseWebComponent } from './guide-enterprise-web/guide-enterprise-web.component';
import { IllustrationComponent } from './illustration/illustration.component';
// import { GuideIosComponent } from './guide-ios/guide-ios.component';
// import { GuideAndroidComponent } from './guide-android/guide-android.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FeaturesComponent,
    PricingComponent,
    GuideComponent,
    FooterComponent,
    GalleryScrollDirective,
    HeroComponent,
    ContactComponent,
    PrivacyPolicyComponent,
    TermsOfServiceComponent,
    DashEnterpriseAuthComponent,
    GuideO365PowershellComponent,
    GuideO365ServiceAccountComponent,
    GuideGoogleComponent,
    GuideGooglePersonalAccountComponent,
    GuideGoogleServiceAccountComponent,
    GuideO365Component,
    GuideO365EnterpriseApplicationComponent,
    GuideEnterpriseComponent,
    GuideEnterpriseDashboardComponent,
    GuideEnterpriseMdmComponent,
    GuideEnterpriseDashboardConfigurationComponent,
    EnterpriseTabNavigatorComponent,
    EnterpriseConfigurationValuesComponent,
    ThumbnailComponent,
    DataDeletionComponent,
    GuideEnterpriseUserAdministrationComponent,
    HardwareComponent,
    GuideEnterpriseWebComponent,
    IllustrationComponent,
    // GuideIosComponent,
    // GuideAndroidComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgsRevealModule,
    HttpClientModule,
    LightboxModule,
    NgOptimizedImage,
  ],
  providers: [],
  bootstrap: [AppComponent, FooterComponent]
})
export class AppModule { }
